// src/components/layout/PageLoader.tsx
import { useEffect, useState } from 'react';
import Logo from '/image.png';

export default function PageLoader({ fullPage = false }: { fullPage?: boolean }) {
  console.log(`[PageLoader] Mounting. Mode: ${fullPage ? 'Full Page' : 'Content Area'}`);
  
  const [dots, setDots] = useState('');
  
  // Animated dots effect
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);
    
    return () => clearInterval(interval);
  }, []);

  const containerClasses = fullPage 
    ? "page-loader-container full-page"
    : "page-loader-container content-area";

  return (
    <div className={containerClasses}>
      <div className="loader-content">
        <div className="logo-container">
          <img src={Logo} alt="Loading..." className="page-loader-logo" />
          <div className="logo-glow"></div>
        </div>
        <div className="loading-text">
          Loading<span className="loading-dots">{dots}</span>
        </div>
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
      </div>
    </div>
  );
}